import { render, staticRenderFns } from "./SimpleText.vue?vue&type=template&id=641d2653&scoped=true&"
import script from "./SimpleText.vue?vue&type=script&lang=js&"
export * from "./SimpleText.vue?vue&type=script&lang=js&"
import style0 from "./SimpleText.vue?vue&type=style&index=0&id=641d2653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d2653",
  null
  
)

export default component.exports